
import axios from "axios";
import CONFIG from "../../../config";

export const saveChangesToBackend = async (statementId, changes) => {
  try {
    const saveUrl = CONFIG.getEndpoint(CONFIG.API.EXCEL.SAVE_CHANGES, true, statementId);
    
    console.log(`📤 Sending ${changes.length} changes to backend for statement ${statementId}`);
    
    // Format changes for backend
    const formattedChanges = changes.map(change => {
      console.log(`Formatting change: ${change.type}`, change);
      
      switch (change.type) {
        case 'edit_cell':
          return {
            type: 'edit_cell',
            row: change.row,
            column: change.column,
            value: change.value,
            operation: change.operation || 'edit'
          };
        case 'insert_row':
          return {
            type: 'insert_row',
            row_index: change.row_index
          };
        case 'delete_row':
          return {
            type: 'delete_row',
            row_index: change.row_index,
            deleted_data: change.deleted_data
          };
        case 'insert_column':
          return {
            type: 'insert_column',
            column_index: change.column_index,
            header: change.header || "New Column"
          };
        case 'delete_column':
          return {
            type: 'delete_column',
            column_index: change.column_index,
            deleted_data: change.deleted_data
          };
        case 'column_resize':
          return {
            type: 'edit_cell', // Treat column resize as a style edit
            row: 1, // Header row
            column: change.columnId,
            value: `Width: ${change.width}px`,
            operation: 'style'
          };
        default:
          console.warn(`Unknown change type: ${change.type}`);
          return change;
      }
    });

    console.log(`Formatted ${formattedChanges.length} changes for backend`);
    
    const response = await axios.post(saveUrl, {
      changes: formattedChanges
    }, {
      headers: CONFIG.getAuthHeaders(),
      timeout: 30000
    });
    
    console.log("✅ Backend response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error saving changes to backend:", error);
    
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
      
      throw new Error(`Server error (${error.response.status}): ${error.response.data?.detail || error.response.statusText}`);
    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");
    } else {
      console.error("Request setup error:", error.message);
      throw error;
    }
  }
};

// Function to validate data before sending
export const validateChanges = (changes) => {
  const errors = [];
  
  changes.forEach((change, index) => {
    if (!change.type) {
      errors.push(`Change ${index}: Missing type`);
    }
    
    switch (change.type) {
      case 'edit_cell':
        if (typeof change.row !== 'number' || change.row < 1) {
          errors.push(`Change ${index}: Invalid row ${change.row}`);
        }
        if (!change.column || typeof change.column !== 'string') {
          errors.push(`Change ${index}: Invalid column ${change.column}`);
        }
        break;
        
      case 'insert_row':
      case 'delete_row':
        if (typeof change.row_index !== 'number' || change.row_index < 1) {
          errors.push(`Change ${index}: Invalid row_index ${change.row_index}`);
        }
        break;
        
      case 'insert_column':
      case 'delete_column':
        if (typeof change.column_index !== 'number' || change.column_index < 1) {
          errors.push(`Change ${index}: Invalid column_index ${change.column_index}`);
        }
        break;
    }
  });
  
  return errors;
};
